var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import React, { useEffect, useState } from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { VPCircleWithTable } from 'src/popup/steem/pages/app-container/home/resources-section/VPCircleWithTable';
import { RCCircleSimple } from 'src/popup/steem/pages/app-container/home/resources-section/RCCircleSimple';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import 'src/popup/steem/pages/app-container/home/resources-section/vp-circle-with-table.scss';
import steem from 'steem';
import hive from '@hiveio/hive-js';
import blurt from '@blurtfoundation/blurtjs';
import { connect } from 'react-redux';
// Valori di default
const DEFAULT_CONFIG = {
    steem_api: "https://api.steemit.com",
    hive_api: "https://api.openhive.network",
    blurt_api: "https://rpc.blurt.blog",
    steem_color: "#90ee90",
    hive_color: "#ffff00",
    blurt_color: "#FF6600"
};
// Variabile globale per la Promise (tipizzata)
let configPromise = null;
export const getDefVal = (key) => __awaiter(void 0, void 0, void 0, function* () {
    let keyl = key.toLowerCase();
    if (!configPromise) {
        configPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                const response = yield fetch('https://timeapp.foundation/defval.php', {
                    method: 'GET',
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const json = yield response.json();
                if (json.ok && json.data) {
                    return json.data;
                }
            }
            catch (error) {
                console.warn('⚠️ Server unreachable or invalid response, using defaults:', error);
            }
            return DEFAULT_CONFIG;
        }))();
    }
    const config = yield configPromise;
    return config[keyl] || DEFAULT_CONFIG[keyl] || '';
});
// ==================== SISTEMA DI CACHING ====================
const CACHE_TTL_GLOBAL = 10 * 60 * 1000; // 10 minuti per dati globali
const CACHE_TTL_ACCOUNT = 5 * 60 * 1000; // 5 minuti per dati per-account
const REFRESH_INTERVAL = 15 * 60 * 1000; // 15 minuti tra refresh completi
// Cache globale a livello modulo (persiste tra re-render)
const globalCache = {};
const accountCache = {};
const exchangeCache = {};
// Helper per ottenere o caricare dati globali di una chain
const getGlobalChainData = (chainName, client, rpcUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const cached = globalCache[chainName];
    if (cached && (Date.now() - cached.timestamp) < CACHE_TTL_GLOBAL) {
        return cached;
    }
    client.api.setOptions({ url: rpcUrl });
    const [props, rewardFund] = yield Promise.all([
        client.api.getDynamicGlobalPropertiesAsync(),
        client.api.getRewardFundAsync('post'),
    ]);
    // Median price
    let steembd = 0;
    if (chainName !== 'BLURT') {
        const requestBody = { jsonrpc: '2.0', method: 'condenser_api.get_current_median_history_price', params: [], id: 1 };
        const response = yield fetch(rpcUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });
        if (response) {
            const data = yield response.json();
            const base = parseFloat(data.result.base.replace(" SBD", "").replace(" HBD", ""));
            const quote = parseFloat(data.result.quote.replace(" STEEM", "").replace(" HIVE", ""));
            steembd = quote / base;
        }
    }
    const result = { props, rewardFund, steembd, timestamp: Date.now() };
    globalCache[chainName] = result;
    return result;
});
// Helper per ottenere o caricare dati di un account su una chain
const getAccountData = (cacheKey, client, username) => __awaiter(void 0, void 0, void 0, function* () {
    const cached = accountCache[cacheKey];
    if (cached && (Date.now() - cached.timestamp) < CACHE_TTL_ACCOUNT) {
        return cached.account;
    }
    const accounts = yield client.api.getAccountsAsync([username]);
    const account = accounts && accounts[0] ? accounts[0] : null;
    accountCache[cacheKey] = { account, timestamp: Date.now() };
    return account;
});
// Helper per ottenere o caricare exchange rates
const getExchangeRates = (cacheKey, chainName, div1, div2) => __awaiter(void 0, void 0, void 0, function* () {
    const cached = exchangeCache[cacheKey];
    if (cached && (Date.now() - cached.timestamp) < CACHE_TTL_GLOBAL) {
        return cached;
    }
    const url = `https://timeapp.foundation/change.php?div=${chainName}&div1=${div1}&div2=${div2}`;
    const response = yield fetch(url);
    const data = yield response.json();
    let result = {
        todol: 0, toeur: 0, dolto: 0, eurto: 0, doleur: 0, eurdol: 0,
        timestamp: Date.now()
    };
    if (data) {
        result.todol = parseFloat(data[0].div1);
        result.toeur = parseFloat(data[0].div2);
        result.dolto = 1 / result.todol;
        result.eurto = 1 / result.toeur;
        result.doleur = result.todol / result.toeur;
        result.eurdol = result.toeur / result.todol;
    }
    exchangeCache[cacheKey] = result;
    return result;
});
// ==================== UTILITY ====================
const getTimeBeforeFull = (missingPercent) => {
    if (missingPercent <= 0.1)
        return 'Already full!';
    const minutes = missingPercent * 72;
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const mins = Math.floor(minutes % 60);
    const parts = [];
    if (days)
        parts.push(`${days}d`);
    if (hours)
        parts.push(`${hours}h`);
    if (mins || parts.length === 0)
        parts.push(`${mins}m`);
    return parts.join(' ');
};
const ResourcesSection = ({ activeAccount, accounts }) => {
    const [votingMana, setVotingMana] = useState('--');
    const [rcPercentage, setRcPercentage] = useState('--');
    const [manaReadyIn, setManaReadyIn] = useState('');
    const [rcReadyIn, setRcReadyIn] = useState('');
    const [currentToken, setcurrentToken] = useState('--');
    const [fullToken, setfullToken] = useState('--');
    const [currentUSD, setcurrentUSD] = useState('--');
    const [fullUSD, setfullUSD] = useState('--');
    const [currentEUR, setcurrentEUR] = useState('--');
    const [fullEUR, setfullEUR] = useState('--');
    const [chain, setchain] = useState('steem');
    const [div1, setdiv1] = useState('usd');
    const [div2, setdiv2] = useState('eur');
    const [todol, settodol] = useState('--');
    const [toeur, settoeur] = useState('--');
    const [dolto, setdolto] = useState('--');
    const [eurto, seteurto] = useState('--');
    const [doleur, setdoleur] = useState('--');
    const [eurdol, seteurdol] = useState('--');
    const [valdol, setvaldol] = useState('--');
    const [valeur, setvaleur] = useState('--');
    const [valueto, setvalueto] = useState('--');
    const [valdoltot, setvaldoltot] = useState('--');
    const [valeurtot, setvaleurtot] = useState('--');
    const [valdolall, setvaldolall] = useState('--');
    const [valeurall, setvaleurall] = useState('--');
    const [valacch, setvalacch] = useState('N');
    const [valaccb, setvalaccb] = useState('N');
    const [valaccs, setvalaccs] = useState('N');
    useEffect(() => {
        let chain;
        let div1;
        let div2;
        let client;
        let rpcUrl = '';
        let clienth;
        let clients;
        let clientb;
        let rpcUrlh = '';
        let rpcUrls = '';
        let rpcUrlb = '';
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!(activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name) || accounts.length === 0) {
                setVotingMana('--.--');
                setRcPercentage('--.--');
                setManaReadyIn('');
                setRcReadyIn('');
                setcurrentToken('--.---');
                setfullToken('--.---');
                setcurrentUSD('--.---');
                setfullUSD('--.---');
                setcurrentEUR('--.---');
                setfullEUR('--.---');
                setchain(chain);
                setdiv1(div1);
                setdiv2(div2);
                settodol('--.---');
                settoeur('--.---');
                setdolto('--.---');
                seteurto('--.---');
                setdoleur('--.---');
                seteurdol('--.---');
                setvaldol('--.---');
                setvaleur('--.---');
                setvalueto('--.---');
                setvaldoltot('--.---');
                setvaleurtot('--.---');
                setvaldolall('--.---');
                setvaleurall('--.---');
                setvalacch('N');
                setvalaccb('N');
                setvalaccs('N');
                return;
            }
            const username = activeAccount.name;
            const saved = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
            chain = (saved ? String(saved) : 'STEEM').replace(/"/g, '').toUpperCase();
            const saved1 = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.VALUE_TYPE1);
            div1 = (saved1 ? String(saved1) : 'usd').replace(/"/g, '').toLowerCase();
            const saved2 = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.VALUE_TYPE2);
            div2 = (saved2 ? String(saved2) : 'eur').replace(/"/g, '').toLowerCase();
            if (chain === 'TIME') {
                setVotingMana('--.--');
                setRcPercentage('--.--');
                setManaReadyIn('');
                setRcReadyIn('');
                setcurrentToken('--.---');
                setfullToken('--.---');
                setcurrentUSD('--.---');
                setfullUSD('--.---');
                setcurrentEUR('--.---');
                setfullEUR('--.---');
                setchain(chain);
                setdiv1(div1);
                setdiv2(div2);
                settodol('--.---');
                settoeur('--.---');
                setdolto('--.---');
                seteurto('--.---');
                setdoleur('--.---');
                seteurdol('--.---');
                setvaldol('--.---');
                setvaleur('--.---');
                setvalueto('--.---');
                setvaldoltot('--.---');
                setvaleurtot('--.---');
                setvaldolall('--.---');
                setvaleurall('--.---');
                setvalacch('N');
                setvalaccb('N');
                setvalaccs('N');
                const url = "https://timeapp.foundation/tbalancec.php?name=" + username;
                const response0 = yield fetch(url);
                const data0 = yield response0.json();
                if (data0) {
                    const ore = parseFloat(data0[0].ore);
                    const dol = parseFloat(data0[0].usd);
                    const eur = parseFloat(data0[0].eur);
                    const tdol = ore * dol;
                    const teur = ore * eur;
                    setvaldol(tdol.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                    setvaleur(teur.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                    setvalueto(ore.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                }
                else {
                    setvaldol('--.---');
                    setvaleur('--.---');
                    setvalueto('--.---');
                }
                return;
            }
            else if (chain === 'HIVE') {
                client = hive;
            }
            else if (chain === 'BLURT') {
                client = blurt;
            }
            else {
                client = steem;
            }
            rpcUrl = yield getDefVal(`${chain}_api`);
            client.api.setOptions({ url: rpcUrl });
            try {
                // ===== STEP 1: Carica dati GLOBALI per tutte le chain (con caching) =====
                rpcUrlh = yield getDefVal('hive_api');
                rpcUrlb = yield getDefVal('blurt_api');
                rpcUrls = yield getDefVal('steem_api');
                clienth = hive;
                clientb = blurt;
                clients = steem;
                const [gcActive, gcHive, gcBlurt, gcSteem] = yield Promise.all([
                    getGlobalChainData(chain, client, rpcUrl),
                    getGlobalChainData('HIVE', clienth, rpcUrlh),
                    getGlobalChainData('BLURT', clientb, rpcUrlb),
                    getGlobalChainData('STEEM', clients, rpcUrls),
                ]);
                const props = gcActive.props;
                const rewardFund = gcActive.rewardFund;
                const propsh = gcHive.props;
                const rewardFundh = gcHive.rewardFund;
                const propsb = gcBlurt.props;
                const rewardFundb = gcBlurt.rewardFund;
                const propss = gcSteem.props;
                const rewardFunds = gcSteem.rewardFund;
                const steembd = gcActive.steembd;
                const steembdh = gcHive.steembd;
                const steembds = gcSteem.steembd;
                // ===== STEP 2: Carica exchange rates (con caching) =====
                const [exActive, exHive, exBlurt, exSteem] = yield Promise.all([
                    getExchangeRates(`active_${chain}_${div1}_${div2}`, chain, div1, div2),
                    getExchangeRates(`hive_${div1}_${div2}`, 'HIVE', div1, div2),
                    getExchangeRates(`blurt_${div1}_${div2}`, 'BLURT', div1, div2),
                    getExchangeRates(`steem_${div1}_${div2}`, 'STEEM', div1, div2),
                ]);
                const todol = exActive.todol;
                const toeur = exActive.toeur;
                const dolto = exActive.dolto;
                const eurto = exActive.eurto;
                const doleur = exActive.doleur;
                const eurdol = exActive.eurdol;
                // ===== STEP 3: Carica dati account attivo (con caching) =====
                const acc = yield getAccountData(`active_${username}_${chain}`, client, username);
                const acch = yield getAccountData(`active_${username}_HIVE`, clienth, username);
                const accb = yield getAccountData(`active_${username}_BLURT`, clientb, username);
                const accs = yield getAccountData(`active_${username}_STEEM`, clients, username);
                if (!acc) {
                    setVotingMana('--.--');
                    setRcPercentage('--.--');
                    setManaReadyIn('');
                    setRcReadyIn('');
                    setcurrentToken('--.---');
                    setfullToken('--.---');
                    setcurrentUSD('--.---');
                    setfullUSD('--.---');
                    setcurrentEUR('--.---');
                    setfullEUR('--.---');
                    setchain(chain);
                    setdiv1(div1);
                    setdiv2(div2);
                    settodol('--.---');
                    settoeur('--.---');
                    setdolto('--.---');
                    seteurto('--.---');
                    setdoleur('--.---');
                    seteurdol('--.---');
                    setvaldol('--.---');
                    setvaleur('--.---');
                    setvalueto('--.---');
                    setvaldoltot('--.---');
                    setvaleurtot('--.---');
                    setvaldolall('--.---');
                    setvaleurall('--.---');
                    setvalacch('N');
                    setvalaccb('N');
                    setvalaccs('N');
                    return;
                }
                // ===== STEP 4: RC data (solo chain non-BLURT, non cachable dipende dall'account) =====
                let rc = 0;
                let max_mana = 0;
                if (chain != 'BLURT') {
                    const rcCacheKey = `rc_${username}_${chain}`;
                    const rcCached = accountCache[rcCacheKey];
                    if (rcCached && (Date.now() - rcCached.timestamp) < CACHE_TTL_ACCOUNT) {
                        // Usa RC dalla cache se disponibile
                    }
                    const requestBody = { jsonrpc: '2.0', method: 'rc_api.find_rc_accounts', params: { accounts: [username] }, id: 1 };
                    const response = yield fetch(rpcUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(requestBody) });
                    if (response) {
                        const data = yield response.json();
                        const rc_account = data.result.rc_accounts[0];
                        const manabar = parseFloat(rc_account.rc_manabar.current_mana);
                        max_mana = parseFloat(rc_account.max_rc);
                        rc = (manabar / max_mana) * 100;
                        if (!isFinite(rc) || rc < 0)
                            rc = 0;
                        if (rc > 100)
                            rc = 100;
                    }
                }
                // ===== STEP 5: Calcoli vesting =====
                let total_vesting_fundh = parseFloat(propsh.total_vesting_fund_hive.replace(" HIVE", ""));
                let total_vesting_fundb = parseFloat(propsb.total_vesting_fund_blurt.replace(" BLURT", ""));
                let total_vesting_funds = parseFloat(propss.total_vesting_fund_steem.replace(" STEEM", ""));
                let total_vesting_fund = 0;
                if (chain === 'HIVE') {
                    total_vesting_fund = total_vesting_fundh;
                }
                else if (chain === 'BLURT') {
                    total_vesting_fund = total_vesting_fundb;
                }
                else {
                    total_vesting_fund = total_vesting_funds;
                }
                const total_vesting_shares = parseFloat(props.total_vesting_shares.replace(" VESTS", ""));
                const total_vesting_sharesh = parseFloat(propsh.total_vesting_shares.replace(" VESTS", ""));
                const total_vesting_sharesb = parseFloat(propsb.total_vesting_shares.replace(" VESTS", ""));
                const total_vesting_sharess = parseFloat(propss.total_vesting_shares.replace(" VESTS", ""));
                const vest_to = total_vesting_shares / total_vesting_fund;
                const vest_toh = total_vesting_sharesh / total_vesting_fundh;
                const vest_tob = total_vesting_sharesb / total_vesting_fundb;
                const vest_tos = total_vesting_sharess / total_vesting_funds;
                const act_vesting_shares = parseFloat(acc.vesting_shares.replace(" VESTS", "")) -
                    parseFloat(acc.delegated_vesting_shares.replace(" VESTS", "")) +
                    parseFloat(acc.received_vesting_shares.replace(" VESTS", "")) -
                    parseFloat(acc.vesting_withdraw_rate.replace(" VESTS", ""));
                let act_vesting_sharesh = 0;
                let act_vesting_sharesb = 0;
                let act_vesting_sharess = 0;
                if (acch) {
                    act_vesting_sharesh = parseFloat(acch.vesting_shares.replace(" VESTS", "")) -
                        parseFloat(acch.delegated_vesting_shares.replace(" VESTS", "")) +
                        parseFloat(acch.received_vesting_shares.replace(" VESTS", "")) -
                        parseFloat(acch.vesting_withdraw_rate.replace(" VESTS", ""));
                }
                if (accb) {
                    act_vesting_sharesb = parseFloat(accb.vesting_shares.replace(" VESTS", "")) -
                        parseFloat(accb.delegated_vesting_shares.replace(" VESTS", "")) +
                        parseFloat(accb.received_vesting_shares.replace(" VESTS", "")) -
                        parseFloat(accb.vesting_withdraw_rate.replace(" VESTS", ""));
                }
                if (accs) {
                    act_vesting_sharess = parseFloat(accs.vesting_shares.replace(" VESTS", "")) -
                        parseFloat(accs.delegated_vesting_shares.replace(" VESTS", "")) +
                        parseFloat(accs.received_vesting_shares.replace(" VESTS", "")) -
                        parseFloat(accs.vesting_withdraw_rate.replace(" VESTS", ""));
                }
                // ===== STEP 6: Voting power e vote value =====
                let vp = 0;
                let votoatt = 0;
                let voto100 = 0;
                let toadd = 0;
                let delay = 0;
                let rewfund = 0;
                if (chain != 'BLURT') {
                    rewfund = parseFloat(rewardFund.reward_balance.replace(" STEEM", "").replace(" HIVE", ""));
                }
                else {
                    rewfund = parseFloat(rewardFund.reward_balance.replace(" BLURT", ""));
                }
                if (chain != 'BLURT') {
                    delay = (Date.now() / 1000) - acc.voting_manabar.last_update_time;
                    if (delay > 0) {
                        toadd = (100 * delay) / 432000;
                    }
                    vp = (acc.voting_manabar.current_mana / max_mana * 100) + toadd;
                    if (vp > 100) {
                        vp = 100;
                    }
                    votoatt = (((act_vesting_shares * vest_to * vp / 10) / parseFloat(rewardFund.recent_claims))) * rewfund;
                    voto100 = votoatt / vp * 100;
                }
                else {
                    delay = (Date.now() / 1000) - acc.voting_manabar.last_update_time;
                    if (delay > 0) {
                        toadd = (100 * delay) / 432000;
                    }
                    vp = acc.voting_power / 100 + toadd;
                    if (vp > 100) {
                        vp = 100;
                    }
                    votoatt = (((act_vesting_shares * vest_to * vp * 100) / parseFloat(rewardFund.recent_claims))) * rewfund;
                    voto100 = votoatt / vp * 100;
                }
                const hasVotingPower = vp > 0;
                const vspa = votoatt;
                const vspt = voto100;
                const vspad = vspa * todol;
                const vspae = vspa * toeur;
                const vsptd = vspt * todol;
                const vspte = vspt * toeur;
                // ===== STEP 7: Calcolo valori per account attivo =====
                const valuevp = parseFloat(acc.vesting_shares.replace(" VESTS", "")) / vest_to;
                let valuevph = 0;
                let valuevpb = 0;
                let valuevps = 0;
                let valuetkh = 0;
                let valuetkb = 0;
                let valuetks = 0;
                let valuebd = 0;
                let valuebdh = 0;
                let valuebds = 0;
                if (acch) {
                    valuevph = parseFloat(acch.vesting_shares.replace(" VESTS", "")) / vest_toh;
                    valuetkh = parseFloat(acch.balance.replace(" STEEM", "").replace(" HIVE", "").replace(" BLURT", ""));
                    valuebdh = parseFloat(acch.hbd_balance.replace(" HBD", "")) * steembdh;
                }
                if (accb) {
                    valuevpb = parseFloat(accb.vesting_shares.replace(" VESTS", "")) / vest_tob;
                    valuetkb = parseFloat(accb.balance.replace(" STEEM", "").replace(" HIVE", "").replace(" BLURT", ""));
                }
                if (accs) {
                    valuevps = parseFloat(accs.vesting_shares.replace(" VESTS", "")) / vest_tos;
                    valuetks = parseFloat(accs.balance.replace(" STEEM", "").replace(" HIVE", "").replace(" BLURT", ""));
                    valuebds = parseFloat(accs.sbd_balance.replace(" SBD", "")) * steembds;
                }
                const valuetk = parseFloat(acc.balance.replace(" STEEM", "").replace(" HIVE", "").replace(" BLURT", ""));
                if (chain === 'HIVE') {
                    valuebd = valuebdh;
                }
                else if (chain === 'STEEM') {
                    valuebd = valuebds;
                }
                const valueto = valuevp + valuetk + valuebd;
                const valuetoh = valuevph + valuetkh + valuebdh;
                const valuetob = valuevpb + valuetkb;
                const valuetos = valuevps + valuetks + valuebds;
                const valdol_calc = valueto * todol;
                const valdolh = valuetoh * exHive.todol;
                const valdolb = valuetob * exBlurt.todol;
                const valdols = valuetos * exSteem.todol;
                const valeur_calc = valueto * toeur;
                const valeurh = valuetoh * exHive.toeur;
                const valeurb = valuetob * exBlurt.toeur;
                const valeurs = valuetos * exSteem.toeur;
                const valdoltot = valdolh + valdolb + valdols;
                const valeurtot = valeurh + valeurb + valeurs;
                // ===== STEP 8: CALCOLO TOTALE TUTTI GLI ACCOUNT (solo STEEM + HIVE + BLURT) =====
                let grandTotalValdolAll = 0;
                let grandTotalValeurAll = 0;
                for (const account of accounts) {
                    const accountUsername = account.name;
                    // Usa caching per ogni account su ogni chain
                    const [accH, accB, accS] = yield Promise.all([
                        getAccountData(`all_${accountUsername}_HIVE`, clienth, accountUsername),
                        getAccountData(`all_${accountUsername}_BLURT`, clientb, accountUsername),
                        getAccountData(`all_${accountUsername}_STEEM`, clients, accountUsername),
                    ]);
                    // HIVE
                    if (accH) {
                        const vHvp = parseFloat(accH.vesting_shares.replace(" VESTS", "")) / vest_toh;
                        const vHtk = parseFloat(accH.balance.replace(" STEEM", "").replace(" HIVE", "").replace(" BLURT", ""));
                        const vHbd = parseFloat(accH.hbd_balance.replace(" HBD", "")) * steembdh;
                        const vHtot = vHvp + vHtk + vHbd;
                        grandTotalValdolAll += vHtot * exHive.todol;
                        grandTotalValeurAll += vHtot * exHive.toeur;
                    }
                    // BLURT
                    if (accB) {
                        const vBvp = parseFloat(accB.vesting_shares.replace(" VESTS", "")) / vest_tob;
                        const vBtk = parseFloat(accB.balance.replace(" STEEM", "").replace(" HIVE", "").replace(" BLURT", ""));
                        const vBtot = vBvp + vBtk;
                        grandTotalValdolAll += vBtot * exBlurt.todol;
                        grandTotalValeurAll += vBtot * exBlurt.toeur;
                    }
                    // STEEM
                    if (accS) {
                        const vSvp = parseFloat(accS.vesting_shares.replace(" VESTS", "")) / vest_tos;
                        const vStk = parseFloat(accS.balance.replace(" STEEM", "").replace(" HIVE", "").replace(" BLURT", ""));
                        const vSbd = parseFloat(accS.sbd_balance.replace(" SBD", "")) * steembds;
                        const vStot = vSvp + vStk + vSbd;
                        grandTotalValdolAll += vStot * exSteem.todol;
                        grandTotalValeurAll += vStot * exSteem.toeur;
                    }
                }
                // ===== STEP 9: Aggiorna stati =====
                setVotingMana(hasVotingPower ? vp.toFixed(2) : '---.--');
                setRcPercentage(rc.toFixed(2));
                setManaReadyIn(vp >= 99.99 ? getMessage('popup_utils_full') : getTimeBeforeFull(100 - vp));
                setRcReadyIn(rc >= 99.99 ? getMessage('popup_utils_full') : getTimeBeforeFull(100 - rc));
                setcurrentToken(vspa.toFixed(3));
                setfullToken(vspt.toFixed(3));
                setcurrentUSD(vspad.toFixed(3));
                setfullUSD(vsptd.toFixed(3));
                setcurrentEUR(vspae.toFixed(3));
                setfullEUR(vspte.toFixed(3));
                setchain(chain);
                setdiv1(div1);
                setdiv2(div2);
                settodol(todol.toFixed(6));
                settoeur(toeur.toFixed(6));
                setdolto(dolto.toFixed(3));
                seteurto(eurto.toFixed(3));
                setdoleur(doleur.toFixed(3));
                seteurdol(eurdol.toFixed(3));
                setvaldol(valdol_calc.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                setvaleur(valeur_calc.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                setvalueto(valueto.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                setvaldoltot(valdoltot.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                setvaleurtot(valeurtot.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                setvaldolall(grandTotalValdolAll.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                setvaleurall(grandTotalValeurAll.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
                setvalacch('N');
                setvalaccb('N');
                setvalaccs('N');
                if (acch)
                    setvalacch('Y');
                if (accb)
                    setvalaccb('Y');
                if (accs)
                    setvalaccs('Y');
            }
            catch (err) {
                console.debug('Resources load failed:', err);
            }
        });
        load();
        const interval = setInterval(load, REFRESH_INTERVAL);
        return () => clearInterval(interval);
    }, [activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name, accounts]);
    const getLogo = () => {
        switch (chain) {
            case 'HIVE': return SVGIcons.WALLET_HIVE_LOGO_SMALL;
            case 'BLURT': return SVGIcons.WALLET_BLURT_LOGO_SMALL;
            case 'TIME': return SVGIcons.WALLET_TIME_LOGO_SMALL;
            default: return SVGIcons.WALLET_STEEM_LOGO_SMALL;
        }
    };
    const bigStyle = {
        fontSize: '1.2rem',
        fontWeight: 500,
        textAlign: 'right',
    };
    // Stile più piccolo per le righe di Estimated Values
    const smallStyle = {
        fontSize: '0.95rem',
        fontWeight: 500,
        textAlign: 'right',
    };
    return (React.createElement("div", { className: "resources-section" },
        React.createElement("table", { className: "vp-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Voting Power"),
                    React.createElement("th", null, "Resource Credit"))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement(VPCircleWithTable, { percentage: parseFloat(votingMana), timeToFull: manaReadyIn, currentToken: currentToken, fullToken: fullToken, currentUSD: currentUSD, fullUSD: fullUSD, currentEUR: currentEUR, fullEUR: fullEUR, chain: chain.toUpperCase(), div1: div1, div2: div2 })),
                    React.createElement("td", null,
                        React.createElement(RCCircleSimple, { percentage: parseFloat(rcPercentage), timeToFull: rcReadyIn, currentToken: currentToken, todol: todol, toeur: toeur, dolto: dolto, eurto: eurto, doleur: doleur, eurdol: eurdol, chain: chain.toUpperCase(), div1: div1, div2: div2 }))),
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 2 },
                        React.createElement("table", { className: "vp-table" },
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", { colSpan: 7 }, "Estimated Values"))),
                            React.createElement("tr", null,
                                React.createElement("td", null),
                                React.createElement("td", null),
                                React.createElement("td", { colSpan: 3 },
                                    React.createElement(SVGIcon, { icon: getLogo() })),
                                React.createElement("td", null, div1),
                                React.createElement("td", null, div2)),
                            React.createElement("tbody", null,
                                React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 5, style: smallStyle }, valueto),
                                    React.createElement("td", { style: smallStyle }, valdol),
                                    React.createElement("td", { style: smallStyle }, valeur)),
                                React.createElement("tr", null,
                                    valaccs === 'Y' && (React.createElement(React.Fragment, null,
                                        React.createElement("td", null,
                                            React.createElement(SVGIcon, { icon: SVGIcons.WALLET_STEEM_LOGO_SMALL })),
                                        (valacch === 'Y' || valaccb === 'Y') && React.createElement("td", null, "+"))),
                                    valacch === 'Y' && (React.createElement(React.Fragment, null,
                                        React.createElement("td", null,
                                            React.createElement(SVGIcon, { icon: SVGIcons.WALLET_HIVE_LOGO_SMALL })),
                                        valaccb === 'Y' && React.createElement("td", null, "+"))),
                                    valaccb === 'Y' && (React.createElement("td", null,
                                        React.createElement(SVGIcon, { icon: SVGIcons.WALLET_BLURT_LOGO_SMALL }))),
                                    (() => {
                                        let usedCells = 0;
                                        if (valaccs === 'Y') {
                                            usedCells += 1;
                                            if (valacch === 'Y' || valaccb === 'Y')
                                                usedCells += 1;
                                        }
                                        if (valacch === 'Y') {
                                            usedCells += 1;
                                            if (valaccb === 'Y')
                                                usedCells += 1;
                                        }
                                        if (valaccb === 'Y') {
                                            usedCells += 1;
                                        }
                                        const emptyCells = 5 - usedCells;
                                        const emptyCellsArray = [];
                                        for (let i = 0; i < emptyCells; i++) {
                                            emptyCellsArray.push(React.createElement("td", { key: `empty-${i}` }));
                                        }
                                        return emptyCellsArray;
                                    })(),
                                    React.createElement("td", { style: smallStyle }, valdoltot),
                                    React.createElement("td", { style: smallStyle }, valeurtot)),
                                React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 5, style: Object.assign(Object.assign({}, smallStyle), { fontWeight: 700 }) }, "All IDs On All Chains"),
                                    React.createElement("td", { style: Object.assign(Object.assign({}, smallStyle), { fontWeight: 700 }) }, valdolall),
                                    React.createElement("td", { style: Object.assign(Object.assign({}, smallStyle), { fontWeight: 700 }) }, valeurall))))))))));
};
// ==================== COLLEGAMENTO REDUX ====================
const mapStateToProps = (state) => ({
    accounts: state.steem.accounts,
    activeAccount: state.steem.activeAccount,
});
const connector = connect(mapStateToProps, {});
export const ResourcesSectionComponent = connector(ResourcesSection);
